import { DefaultQueryParams, parseQuery, resizeGame } from '@pascal/pascal-core';
import { TERMINAL_ID } from '../enums/constants';

const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
const isTerminal = +gameId === TERMINAL_ID;
// Terminal View
const maxWidth = isTerminal ? 1920 : 1494;
const maxHeight = isTerminal ? 1080 : 846;
const target = document.querySelector('.root');
export const resizeGameHandler = () => {
  resizeGame(maxHeight, maxWidth, target);
};
